import { BCMSRecord, BCMSStateManagerCRUD, DisabledPrompt, StateManager, useBCMSContext, useStateManager } from "@bcm-dev/bcms-vite";
import { WidgetContainer, WidgetView } from "components/shared";
import { PrimaryButton, SecondaryButton, UICheckbox } from "components/ui";
import Classes, { Account, ACHBatch } from "model";
import React from "react";
import BatchesACHTableView from "../BatchesACHTableView";
import SearchOptionsFormView from "../SearchOptionsFormView";
import ACHSearch from "../SearchOptionsFormView/classes/ACHSearch";

/**
 * @function PendingSameDayACHBatchesWidget
 * @return {React.Component}
 * @exported true
 * @description This is the main widget used in ActivityACHPage.
 */
export default function PendingSameDayACHBatchesWidget(props) {
  const globalController = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, globalController);

  const data = { ...getDefaultData(), ...props.data ?? {} };
  const ui = { ...getDefaultUI(), ...props.ui ?? {} };

  const controller = (state, setState) => ({
      data: state.data,
      ui: state.ui,

      onChange: prop => val => {
        BCMSStateManagerCRUD.init(state)
        .update([ "data", prop ], val)
        .submit(setState);
      },

      onSelectAllACHBatches: val => {
        const batches = state.data.achBatches.map(item => {
          item.selected = val;
          return item;
        });

        BCMSStateManagerCRUD.init(state)
        .update([ "data", "achBatches" ], batches)
        .submit(setState);
      },

      onACHBatchChange: (id, prop) => val => {
        const batches = state.data.achBatches.map(item => {
          if(item.id === id) {
            item[prop] = val;
          }
          return item;
        });

        BCMSStateManagerCRUD.init(state)
        .update([ "data", "achBatches" ], batches)
        .submit(setState);
      },

      onApproveClick: () => {
        const batches = state.data.achBatches.filter(item => item.selected === true);
        const updatedBatches = batches.reduce((acc, item) => {
          item.selected = false;

          acc.push(
            ACHBatch.init({ ...item.record, status: "pending processing" })
          );
          return acc;
        }, []);

        if(updatedBatches.length === 0) return;

        const recordUpdates = updatedBatches.reduce((acc, item) => {
          acc.push(ACHBatch.update({ ...item.record }));
          return acc;
        }, []);

        BCMSStateManagerCRUD.init(state)
        .update([ "data", "achBatches" ], updatedBatches)
        .submit(setState);

        props.onUpdatePendingSameDayACHBatchesWidgetData("achBatches", updatedBatches);
        props.onUpdatePageData("showSuccessBanner", { show: true });
        props.onUpdatePageData("approvedACHBatch", { batch: updatedBatches[0] });

        BCMSRecord.batch(recordUpdates, globalController, Classes);
      },
 
      onSearchChange: prop => val => {
        BCMSStateManagerCRUD.init(state)
        .update([ "data", "achSearch", prop ], val)
        .submit(setState);
      },

      onClear: () => {
        BCMSStateManagerCRUD.init(state)
        .update([ "data", "achSearch" ], ACHSearch.init())
        .submit(setState);
      }
  });

  return (
    <StateManager state={ { data, ui } } controller={ controller }>
      <WidgetContent/>
    </StateManager>
  )
}

export const getDefaultData = () => ({
  //companyAccounts: CompanyAccount.initAll(), // may be used later
  //linkedAccounts: LinkedAccount.initAll(), // may be used later
  widgetType: { type: "pendingSameDay" },
  showSearchOptions: false,
  achSearch: ACHSearch.init(),
  businessAccounts: Account.initAllBusinessAsset(),
});

export const getDefaultUI = () => ({
  // no ui changes for now
});

function WidgetContent(props) {
  const { data, onACHBatchChange, onApproveClick, onChange, onSelectAllACHBatches } = useStateManager();
  const widgetType = data.widgetType ?? {};
  const isPendingSameDayWidget = widgetType.type === "pendingSameDay";
    const allBatchesAreInPendingProcessing = data.achBatches.filter(item => item.status === "pending processing").length === data.achBatches.length;
  const someBatchesAreSelected = data.achBatches.filter(item => item.selected === true).length > 0;

  return(
    <WidgetContainer className="pending-same-day-ach-batches-widget">
      <WidgetView dataPoint="Pending_Same_Day_ACH_Batches_Label" text="Pending (Same Day) ACH Batches">
        <UICheckbox label="Show Search Options" value={ data.showSearchOptions ? "checked" : "" } 
        onChange={ onChange("showSearchOptions")} />
        { data.showSearchOptions && 
        <SearchOptionsFormView offsetAccounts={ data.businessAccounts } />
        }
        <BatchesACHTableView data={ data } onACHBatchChange={ onACHBatchChange } onSelectAllACHBatches={ onSelectAllACHBatches } />
        <div className="button-container flex-container flex-horizontal">
          <DisabledPrompt>
            <SecondaryButton className="export-button" text="Export" />
          </DisabledPrompt>
          { isPendingSameDayWidget && !allBatchesAreInPendingProcessing && 
          <>
            <span>
              <DisabledPrompt>
                <PrimaryButton className="reject-button" text="Reject" dataPoint={ `Pending_Same_Day_ACH_Batches_Reject_Button` } />
              </DisabledPrompt>
            </span>
            { isPendingSameDayWidget
            && <PrimaryButton className="approve-button" text="Approve" dataPoint={ `Pending_Same_Day_ACH_Batches_Approve_Button` }
             onClick={ onApproveClick } /> 
            }
          </>
          }

          { !isPendingSameDayWidget &&
          <span>
            <DisabledPrompt>
              <PrimaryButton className="approve-button" text="Approve" />
            </DisabledPrompt>
          </span>
          }
        </div>
      </WidgetView>
    </WidgetContainer>
  );
}
